import { observer } from 'mobx-react-lite'
import React, { Fragment, useMemo } from 'react'
import StatisticBox from './StatisticBox'
import { countries } from 'countries-list'
import { Flag, Person } from 'react-bootstrap-icons'
import { formatNumber } from '../../../../../utils/Helper'
import { toastSuccess } from '../../../../FormComponents/Toasts'
import UF from '../../../../FormComponents/UpdatableField'

export default observer(function StatisticBoxes({ currentAuthentication }) {
  const audienceInformation = useMemo(() => currentAuthentication?.audience_information || null ,[currentAuthentication, currentAuthentication?.id, currentAuthentication?.audience_information])
  const topCountry = useMemo(() => audienceInformation?.detailed_audience_stats?.country?.[0], [audienceInformation, audienceInformation?.id])
  const topGender = useMemo(() => audienceInformation?.detailed_audience_stats?.gender ? Object.keys(audienceInformation.detailed_audience_stats.gender || {}).find(gender => audienceInformation.detailed_audience_stats.gender[gender] >= 0.5) : null, [audienceInformation, audienceInformation?.id])
  const topGenderText = useMemo(() => !topGender ? '' : topGender === 'male' ? 'Male' : 'Female', [topGender])
  const topGenderPercentage = useMemo(() => !topGender ? '' : (audienceInformation?.detailed_audience_stats?.gender?.[topGender] * 100).toFixed(2), [topGender])
  const topCountryPercentage = useMemo(() => !topCountry ? '' : `${(topCountry?.percentage * 100).toFixed(2)}%`, [currentAuthentication.audience_information?.detailed_audience_stats?.country[0]?.percentage])
  const fakeFollowerRateText = useMemo(() => !currentAuthentication.audience_information?.fake_follower_rate ? '' : formatNumber(currentAuthentication.reach * +currentAuthentication.audience_information?.fake_follower_rate), [currentAuthentication.audience_information?.fake_follower_rate, currentAuthentication.reach])
  const fakeFollowerRatePercentage = useMemo(() => !currentAuthentication.audience_information?.fake_follower_rate ? '' : (currentAuthentication.audience_information?.fake_follower_rate * 100).toFixed(2), [currentAuthentication.audience_information?.fake_follower_rate])

  return (
    <Fragment>
        <StatisticBox
          editable
          name="Engagement rate"
          authentication = {currentAuthentication}
          icon={<Person />}
          value={`${formatNumber((+currentAuthentication.engagement_rate * 100).toFixed(2))}%`}
          manipulateValue={(value) => {
            const number = value.replace('%', '').trim()
            return number / 100
          }}
          onFieldUpdate={(value) => {
            currentAuthentication.engagement_rate = value.engagement_rate
            toastSuccess("Engagement rate has been updated")
          }}
          updatePath={`/api/project_manager/authentications/${currentAuthentication.id}`}
          attribute='engagement_rate'
        />
        <StatisticBox name="Followers" icon={<Person />} value={formatNumber(currentAuthentication.reach)} />

        <div className="w-full bg-white dark:bg-rb-dark-mode p-4 rounded-lg">
          <div className="flex items-center">
            <div className="text-gray-300 dark:text-gray-400"><Flag /></div>
            <p className="text-sm dark:text-white">Top country</p>
          </div>
          <div className="w-full h-full pb-4 flex flex-col items-end justify-end">
            <span className="font-bold text-xl dark:text-white">{countries[topCountry?.country_code]?.name}</span>
            <UF
              url={`/api/project_manager/authentications/${currentAuthentication.id}/update_top_country_percentage`}
              model="authentication"
              attribute="audience_information.top_country_percentage"
              className="text-xs h-5"
              manipulateValue={(value) => {
                const number = value.replace('%', '').trim()
                return number / 100
              }}
              onFieldUpdate={(value) => {
                if (currentAuthentication.audience_information?.detailed_audience_stats?.country?.[0]) {
                  currentAuthentication.audience_information.detailed_audience_stats.country[0].percentage = value.detailed_audience_stats.country[0].percentage
                  toastSuccess("Top country has been updated")
                }
              }}
            >
              {topCountryPercentage}
            </UF>
          </div>
        </div>

        <StatisticBox name="Top gender" icon={<Person />} value={topGenderText} percentage={topGenderPercentage} />
        <StatisticBox
          editable
          name="Fake followers"
          authentication = {currentAuthentication}
          icon={<Flag />}
          value={fakeFollowerRateText}
          manipulateValue={(value) => {
            const rate = value / currentAuthentication.reach
            return rate
          }}
          onFieldUpdate={(value) => {
            if (currentAuthentication.audience_information) {
              currentAuthentication.audience_information.fake_follower_rate = value.fake_follower_rate
              toastSuccess("Fake follower rate has been updated")
            }
          }}
          updatePath={`/api/project_manager/authentications/${currentAuthentication.id}`}
          attribute='audience_information.fake_follower_rate'
          percentage={fakeFollowerRatePercentage}
        />
    </Fragment>
  )
})